import type { SortingState } from '@tanstack/react-table';
import { useEffect, useState } from 'react';
import { useOutletContext } from 'react-router-dom';

import { SlideOut } from '~/components/SlideOut/SlideOut';
import { ArtistHeader } from '~/modules/artist-roster/pages/artist-details/components/ArtistHeader/ArtistHeader';
import { FeedbackRequestModal } from '~/modules/artist-roster/pages/artist-details/components/FeedbackRequestModal/FeedbackRequestModal';
import { PreReleaseTable } from '~/modules/artist-roster/pages/artist-details/pages/artist-pre-releases/components/PreReleaseTable/PreReleaseTable';
import { PreReleaseTableHeader } from '~/modules/artist-roster/pages/artist-details/pages/artist-pre-releases/components/PreReleaseTable/PreReleaseTableHeader';
import { TrackPreReleaseBenchmarkPanel } from '~/modules/artist-roster/pages/artist-details/pages/artist-pre-releases/components/TrackPreReleaseList/TrackPreReleaseBenchmarkPanel';
import type { ArtistDetails } from '~/modules/artist-roster/types';
import { useAnalytics } from '~/modules/monitoring/analytics/useAnalytics';

export function ArtistPreReleasesPage() {
  const { trackEvent } = useAnalytics('Artist Roster');
  const [isSlideOutOpen, setIsSlideOutOpen] = useState(false);

  const handleSetBenchmarkButtonClick = () => {
    setIsSlideOutOpen(true);
  };

  const { artistData, scrollUpCallback } = useOutletContext<{
    artistData: ArtistDetails;
    scrollUpCallback: () => void;
  }>();

  useEffect(() => {
    if (artistData) {
      trackEvent('artistPreReleasesView', {
        artist_id: artistData.partyId,
        artist_name: artistData.name,
      });
    }
  }, [trackEvent, artistData]);

  const [sortingState, setSortingState] = useState<SortingState>([
    {
      id: 'initialReleaseDate',
      desc: true,
    },
  ]);

  return (
    <>
      <ArtistHeader {...{ artistData }}>
        <PreReleaseTableHeader
          uaid={artistData.uaid}
          artistData={artistData}
          columnSort={sortingState[0]}
          scrollUpCallback={scrollUpCallback}
        />
      </ArtistHeader>
      <div className="px-xl pb-xl">
        <PreReleaseTable
          uaid={artistData.uaid}
          artistData={artistData}
          columnSort={sortingState[0]}
          onSortingChange={setSortingState}
          handleSetBenchmarkButtonClick={handleSetBenchmarkButtonClick}
        />
        <SlideOut
          {...{
            open: isSlideOutOpen,
            onOpenChange: setIsSlideOutOpen,
            panelWidth: '1080px',
          }}
        >
          <TrackPreReleaseBenchmarkPanel {...{ artistData }} />
        </SlideOut>
      </div>
      <FeedbackRequestModal />
    </>
  );
}

ArtistPreReleasesPage.displayName = 'ArtistPreReleasesPage';
